import { Component } from 'src/utils';
import template from './subscription-email.html';
import resetPwdImg from './../../../images/reset-pass-2.png';
import confirmImg from './../../../images/tick-sent.png';


@Component({
  controllerAs: 'subscriptionEmail',
  template
})

export default class ActivateContainer {
  static $inject = [
    '$scope',
    '$stateParams',
    '$ngRedux',
    'authActions',
    'authService'
  ];

  constructor($scope, $stateParams, $ngRedux, authActions, authService) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$ngRedux = $ngRedux;
    this.$stateParams = $stateParams;
    this.authActions = authActions;
    this.authService = authService;
    this.resetPwdImg = resetPwdImg;
    this.confirmImg = confirmImg;
    this.storeName = $stateParams.storeName;
    this.activate();

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      auth: state.auth
    };
  }

  activate() {
    this.authService.cancelSubscriptionfromEmail({
      token: this.$stateParams.token
    })
      .then(() => this.activationsuccess = true)
      .catch(err => {
        //  console.log(err);
        if (err.data.errorCode === 624 ) {
          this.alreadyUser = 'The Subscripiton Cycle is expired';
        }
        else {
          this.activationerror = err.data.message;
        }
      });
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/subscription-email/subscription-email.js